var POSITIONS = {
  RIGHT: "right",
  LEFT: "left"
};
export default POSITIONS;